module.exports = __webpack_public_path__ + "img/2_roues.02aed141.png";